import { Loader } from '@progress/kendo-react-indicators'

interface IProps {
  message?: string
}

/**
 * Spinner centrado que cubre el contenedor posicionado más cercano.
 * Para grids usar LoadingGrid; para operaciones largas LoadingModal;
 * para carga inline con mensaje LoadingSmall.
 */
export const Loading: React.FC<IProps> = ({ message }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center gap-3"
      style={{ position: 'absolute', inset: 0, minHeight: '120px' }}
    >
      <Loader type="infinite-spinner" size="large" themeColor="primary" />
      {message && <small className="text-muted">{message}</small>}
    </div>
  )
}
